module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/chicken-mobile-portuguese.fae2986f.jpg";